module.exports = __webpack_public_path__ + "static/media/mechwangu_default_services.c34f8994.svg";